import { Component, Input } from "@angular/core";
import { Router } from "@angular/router";
import { NbDialogRef, NbDialogService } from "@nebular/theme";
import { User } from "../../../@core/data/users";
import { Employee } from "../../../models/employee.model";
import { Finance } from "../../../models/finance.model";
import { Person } from "../../../models/person.model";
import { Catalog } from "../../../models/product.model";
import Shop from "../../../models/shop.model";
import { DialogFinanceComponent } from "../../dialog-finance/dialog-finance.component";

@Component({
  selector: "ngx-dialog-finance-prompt",
  templateUrl: "dialog-finance-prompt.component.html",
  styleUrls: ["dialog-finance-prompt.component.scss"],
})
export class DialogFinancePromptComponent {
  @Input() header: string;
  @Input() shopId?: string;
  @Input() shop?: Shop;
  @Input() uid?: string;
  @Input() user?: User;
  @Input() finance?: Finance;
  @Input() mode: string; //new/edit
  @Input() groupFins?: Catalog[] = [];
  @Input() persons?: Person[] = [];
  @Input() type = "receive"; //receive/issue
  @Input() employees?: Employee[];

  constructor(
    protected ref: NbDialogRef<DialogFinancePromptComponent>,
    private dialogService: NbDialogService,
    private router: Router
  ) {}

  cancel() {
    this.ref.close();
  }

  onNew(type) {
    let finance = new Finance();
    finance.shopId = this.shopId;
    finance.isReceive = type === "receive" ? true : false;

    this.dialogService
      .open(DialogFinanceComponent, {
        context: {
          header: "Tạo phiếu thu/chi",
          mode: "new",
          shopId: this.shopId,
          uid: this.uid,
          user: this.user,
          shop: this.shop,
          finance: finance,
          groupFins: this.groupFins,
          persons: this.persons,
          employees: this.employees,
          type: type,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.ref.close(value);
        } else {
          this.cancel();
        }
      });
  }
}
